<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
      </template>
    </c-search-box>
    <!-- 공정 목록 -->
    <c-table
      ref="processTable"
      title="공정 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isExpan="false"
      :isFullScreen="false"
      :rowKey="rowKey"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'process-pop',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: 'multiple',
        // processLevelCd: '20',
        plantCd: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      rowKey: 'processCd',
      listUrl: '',
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '공정',
            align: 'center',
            sortable: true
          },
        ],
        data: [],
        height: '100%'
      },
      searchParam: {
        plantCd: null,
        processName: '',
        processLevelCd: '20',
        useFlag: 'Y'
      },
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      // if (this.popupParam.processLevelCd == '10') {
      //   this.rowKey = 'processCd';
      //   this.grid.columns = [
      //     {
      //       name: 'plantName',
      //       field: 'plantName',
      //       label: 'LBLPLANT',
      //       align: 'center',
      //       sortable: true,
      //     },
      //     {
      //       name: 'processName',
      //       field: 'processName',
      //       label: 'LBL0001700',
      //       align: 'center',
      //       sortable: true,
      //     },
      //   ];
      // } else {
      //   this.rowKey = 'processCd';
      //   this.grid.columns = [
      //     {
      //       name: 'plantName',
      //       field: 'plantName',
      //       label: 'LBLPLANT',
      //       align: 'center',
      //       sortable: true,
      //     },
      //     {
      //       name: 'upProcessName',
      //       field: 'upProcessName',
      //       label: 'LBL0001700',
      //       align: 'center',
      //       sortable: true,
      //     },
      //     {
      //       name: 'processName',
      //       field: 'processName',
      //       label: 'LBL0001701',
      //       align: 'center',
      //       sortable: true
      //     },
      //   ];
      // }
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd
      }
      this.listUrl = selectConfig.mdm.process.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      // this.searchParam.processLevelCd = (this.popupParam.processLevelCd) ? this.popupParam.processLevelCd: '20';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['processTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
